import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { BaseCustomerInquiryOffersSortKeysInterface } from '../../_interfaces/base-customer-inquiry-offers-sort-keys.interface';
import { BaseOrderDirectionEnum } from 'base';

@Component({
  selector: 'base-customer-sort-filter-dropdown',
  templateUrl: './base-customer-sort-filter-dropdown.component.html',
})
export class BaseCustomerSortFilterDropdownComponent {
  @ViewChild('dropdownElement') dropdownElement: ElementRef;
  isOpen = false;
  shouldOpenUpward = false;
  baseOrderDirectionType = BaseOrderDirectionEnum;
  /**
   * Placeholder string; <br/>
   * default = ''
   */
  @Input() placeholder: string = '';
  /**
   * Items to be handed into dropdown options
   */
  @Input() items: any[];
  /**
   * Binding label of dropdown items to a specific data structure; <br/>
   * default = 'name'
   */
  @Input() bindOptionLabel: string = 'name';
  /**
   * Setting direction icon according to input value; <br/>
   */
  @Input() activeOrderDirection: BaseOrderDirectionEnum;
  /**
   * Previously provided sorting option item will be emitted for option that has been clicked <br/>
   */
  @Output() listItemClicked = new EventEmitter<BaseCustomerInquiryOffersSortKeysInterface>();

  toggle(): void {
    const rect = this.dropdownElement.nativeElement.getBoundingClientRect();
    this.shouldOpenUpward = rect.bottom > window.innerHeight;
    this.isOpen = !this.isOpen;
  }

  onClickListItem(event: any): void {
    this.placeholder = event.orderDirection === undefined ? 'action.sort' : event[this.bindOptionLabel];
    this.listItemClicked.emit(event);
  }
}
